import Header from '@/components/Header';
import Footer from '@/components/Footer';
import styles from './Videos.module.scss';
import cn from 'classnames';
import getPostTypeStaticPaths from '@/functions/wp/posts/getPostTypeStaticPaths';
import getPostTypeStaticProps from '@/functions/wp/posts/getPostTypeStaticProps';
import BlockVideo from '@/components/BlockVideo';
import Layout from '@/components/Layout';
import Container from '@/components/Container';
import BlockHeading from '@/components/BlockHeading';
import BlockParagraph from '@/components/BlockParagraph';
import { useQuery } from '@apollo/client';
import getVideoById from '@/lib/wp/content/getVideoById';
import { useRouter } from 'next/router';
import Moment from 'react-moment';
import SocialShare from '@/components/SocialShare';

//const postType = 'post';

/**
 * Render the Post component
 *
 * @param  {object}  props      component attributes as props
 * @param  {object}  props.post post data from WP
 * @return {Element}            Post component
 */
// eslint-disable-next-line react/prop-types
export default function Post({ post}) {
  const { query } = useRouter();
  // eslint-disable-next-line react/prop-types
  const { loading, error, data } = useQuery(getVideoById, { variables: { id: query.id } });
  const content = data?.video;
  const author = content?.author?.node;
  const video = content?.videoinformation;
  const STATIC_DATA = 'STATIC DATA FPO'; //TODO: need to put conditional on basis of the data coming from backend. If no data then show this on header.

  if (loading) {
    return <div>Loading Video...</div>;
  }

  if (content)
    return (
      <Layout seo={{ ...post?.seo }} hasJsonLd hasHubSpot>
        
        <div className={styles.videoWrapper}>
          <Container>
            <div className={styles.videoInnerWrapper}>
              <BlockHeading level={1} content={content?.title} />
              <BlockParagraph customStyle={{color:'#6e6e67'}} content={(video?.description || '')} />
              <p className={styles.date}>
                <Moment format="MMM DD">{content?.date}</Moment> {video.duration && <div> {video?.duration} read </div>}
              </p>
              <div className={styles.divider}></div>
              <div className={styles.videoMeta}>
                  <div className={styles.designation}>
                     {author && 
                      <a href={`/byline?author=${author.name}`}>
                      <BlockHeading level={3} content={author.name} customStyle={{margin:0}} />
                      </a> }
                      
                       <p>Editor at HDM</p>
                  </div>
                <div className={styles.socialMedia}>
                  <p>SHARE:</p>
                  <SocialShare title={content.title} url={window?.location?.href} />
                </div>
              </div>
            </div>
          </Container>
          <Container>
            <div className={styles.videoPlayer}>
              <BlockVideo src={video?.videoFile?.mediaItemUrl} />
            </div>
          </Container>
          {/*<Container>*/}
          {/*  <div className={cn(styles.videoInnerWrapper, styles.additonalContent)}>*/}
          {/*    {STATIC_DATA}*/}
          {/*  <BlockParagraph customStyle={{color:'#6e6e67'}} content="Much has been accomplished. I recall an early HIMSS conference at which an exhibit featured a one terabyte database of images of the globe. It was powered by rack upon rack of networked individual computers. It was a marvel. Now, 20-plus years later, you can hold a terabyte of data in a USB memory stick." />*/}
          {/*  </div>*/}
          {/*</Container>*/}
        </div>
      </Layout>
    );
}

/**
 * Get post static paths.
 *
 * @return {object} Array of paths and fallbacks
 */
// export async function getStaticPaths() {
//   return getPostTypeStaticPaths(postType);
// }

/**
 * Get post static props
 *
 * @param  {object} context        context for current post
 * @param  {object} context.params route parameters for current post
 * @return {object}                post props
 */
// export async function getStaticProps({ params }) {
//   return getPostTypeStaticProps(params, postType);
// }
